/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';

export interface IAntibiotic {
  id?: string;
  name?: string;
  tmClass?: string | null;
  resistanceMechanisms?: string | null;
  notes?: string | null;
  active?: boolean | null;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  mechanismOfAction?: IClinicalDictionary | null;
  spectrum?: IClinicalDictionary | null;
}

export const defaultValue: Readonly<IAntibiotic> = {
  active: false,
};
